import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deletePartnerGeofence = async (id: number) => {
  await mutationExecute({
    mutation: graphql(`
      mutation DelePartnerGeofence($id: Float!) {
        deletePartnerGeofence(id: $id)
      }
    `),
    variables: {
      id,
    },
    fetchPolicy: 'no-cache',
  });
};
